<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">
        Penerimaan - {{ id > 0 ? 'Edit' : 'Tambah' }}
      </span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">
          / Pembelian / Penerimaan / {{ id > 0 ? 'Edit' : 'Tambah' }}
        </span>
      </div>
    </div>
    <!-- <form @submit.prevent="save(!v$.$invalid)"> -->
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          :loading="isLoadingSave"
          icon="pi pi-save"
          class="mr-2"
          :label="id > 0 ? 'Update' : 'Simpan'"
          @click="save(!v$.$invalid)"
        />
        <!-- <Button
            :disabled="
              old_status_value === 'printed' || old_status_value === 'posted'
            "
            icon="pi pi-plus"
            class="p-button-outlined mr-2"
            label="Item"
            @click="onAddData"
          /> -->
        <Button
          class="p-button-link"
          label="Kembali"
          @click="$router.push({ name: 'PurchaseReceive' })"
        />
      </div>
      <div class="grid">
        <div class="col-12 md:col-8">
          <div class="formgrid grid">
            <div class="field col-12 md:col-4">
              <label>No Penerimaan</label>
              <InputText
                v-model="form.rcv_no"
                class="w-full"
                input-class="w-full"
                maxlength="50"
                disabled
              />
            </div>
            <div class="field col-12 md:col-4">
              <label>No SJ</label>
              <InputText
                ref="sj_no"
                v-model="form.sj_no"
                class="w-full"
                input-class="w-full"
                maxlength="50"
                @keydown="handleKeydown($event, 'rcv_at', 'sj_no')"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label>Status</label>
              <Dropdown
                v-model="form.status"
                :options="list_status"
                disabled
                optionValue="value"
                optionLabel="label"
                optionDisabled="disabled"
                class="w-full"
                input-class="w-full"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label>Tgl Terima</label>
              <Calendar
                ref="rcv_at"
                v-model="form.rcv_at"
                dateFormat="dd/mm/yy"
                class="w-full"
                input-class="w-full"
                @keydown="handleKeydown($event, 'sj_at', 'sj_no')"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label>TGL SJ</label>
              <Calendar
                ref="sj_at"
                v-model="form.sj_at"
                dateFormat="dd/mm/yy"
                class="w-full"
                input-class="w-full"
                :show-current="false"
                @keydown="handleKeydown($event, 'disc_reg', 'rcv_at')"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label>DISC Reguler</label>
              <div class="p-inputgroup flex-1">
                <!-- <span v-if="disc_reg > 100" class="p-inputgroup-addon">
                    Rp
                  </span> -->
                <InputNumber
                  ref="disc_reg"
                  v-model="disc_reg"
                  locale="id-ID"
                  class="w-full"
                  input-class="w-full"
                  :min="0"
                  :minFractionDigits="0"
                  :maxFractionDigits="0"
                  @update:model-value="changeDiscReg"
                  @input="disc_reg = $event.value"
                  @focus="selectAllText('disc_reg')"
                  :disabled="
                    old_status_value === 'printed' ||
                    old_status_value === 'posted'
                  "
                />
                <span v-if="disc_reg <= 100" class="p-inputgroup-addon">
                  %
                </span>
              </div>
            </div>

            <div class="col-12">
              <hr class="my-2 border-gray-300" />
            </div>

            <div class="field col-12 md:col-6">
              <label>Supplier</label>
              <Dropdown
                ref="supp_id"
                v-model="form.supp_id"
                :filter="true"
                :options="list_supplier"
                showClear
                class="w-full"
                input-class="w-full"
                optionValue="id"
                optionLabel="name"
                placeholder="Pilih Supplier"
                :disabled="id"
                :class="{
                  'p-invalid': v$.form.supp_id.$invalid && submitted,
                }"
                @change="selectSupplier"
                @hide="onSupplierSelected"
                @filter="onSupplierFilter"
              />
              <small
                v-if="
                  (v$.form.supp_id.$invalid && submitted) ||
                  v$.form.supp_id.$pending.$response
                "
                class="p-error"
                >{{ v$.form.supp_id.required.$message }}</small
              >
            </div>
            <div class="field col-12 md:col-6">
              <label>NO PO</label>
              <Dropdown
                ref="pr_id"
                v-model="itemdetail.pr_id"
                :filter="true"
                :options="list_purchase_order"
                class="w-full"
                input-class="w-full"
                optionValue="id"
                optionLabel="pr_no"
                placeholder="Pilih PO"
                :disabled="
                  old_status_value === 'printed' ||
                  old_status_value === 'posted'
                "
                @change="selectPo"
                @hide="onPoSelected"
              />
            </div>
            <div class="field col-12 md:col-7">
              <label>Item </label>
              <AutoComplete
                ref="item_id"
                v-model="selectedItem"
                class="w-full"
                input-class="w-full"
                :suggestions="filteredItems"
                field="label"
                @complete="searchItem"
                :disabled="
                  old_status_value === 'printed' ||
                  old_status_value === 'posted'
                "
                @item-select="handleItemSelect"
              >
                <template #item="slotProps">
                  <div>
                    <b>{{ slotProps.item.item_barcode_1 }}</b>
                  </div>
                  <div>{{ slotProps.item.item_name }}</div>
                </template>
              </AutoComplete>
            </div>
            <div class="field col-6 md:col-2">
              <label>qty (b)</label>
              <InputNumber
                ref="qty_b"
                v-model="itemdetail.qty_b"
                :class="{
                  'p-invalid': v$.itemdetail.qty_b.$invalid && submitted,
                }"
                class="w-full"
                :min="0"
                locale="id-ID"
                input-class="w-full"
                :disabled="
                  old_status_value === 'printed' ||
                  old_status_value === 'posted'
                "
                @focus="lastQtyInputRef = 'qty_b'"
                @keydown="handleKeydown($event, 'qty_s', 'item_id')"
              />
              <small
                v-if="
                  (v$.itemdetail.qty_b.$invalid && submitted) ||
                  v$.itemdetail.qty_b.$pending.$response
                "
                class="p-error"
              >
                <span v-if="v$.itemdetail.qty_b.required.$invalid">
                  {{ v$.itemdetail.qty_b.required.$message }}
                </span>
                <span v-else-if="v$.itemdetail.qty_b.maxLength.$invalid">
                  {{ v$.itemdetail.qty_b.maxLength.$message }}</span
                >
              </small>
            </div>
            <div class="field col-6 md:col-2">
              <label>qty (s)</label>
              <InputNumber
                ref="qty_s"
                v-model="itemdetail.qty_s"
                :class="{
                  'p-invalid': v$.itemdetail.qty_s.$invalid && submitted,
                }"
                class="w-full"
                :min="0"
                locale="id-ID"
                input-class="w-full"
                :disabled="
                  old_status_value === 'printed' ||
                  old_status_value === 'posted'
                "
                @focus="lastQtyInputRef = 'qty_s'"
                @keydown="handleKeydown($event, 'btnRcvItem', 'qty_b')"
              />
              <small
                v-if="
                  (v$.itemdetail.qty_s.$invalid && submitted) ||
                  v$.itemdetail.qty_s.$pending.$response
                "
                class="p-error"
              >
                <span v-if="v$.itemdetail.qty_s.required.$invalid">
                  {{ v$.itemdetail.qty_s.required.$message }}
                </span>
                <span v-else-if="v$.itemdetail.qty_s.maxLength.$invalid">
                  {{ v$.itemdetail.qty_s.maxLength.$message }}</span
                >
              </small>
            </div>
            <div class="field col-12 md:col-1">
              <label class="opacity-0">Action</label>
              <Button
                ref="btnRcvItem"
                :disabled="
                  old_status_value === 'printed' ||
                  old_status_value === 'posted'
                "
                icon="pi pi-plus"
                class="p-button-outlined w-full"
                @click="onSaveReceiveItem"
                @keydown.enter.prevent="onSaveReceiveItem"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <fx-table
          :items="form.details"
          :total="form.details.length"
          :loading="isLoading"
          :paginator="false"
          hasFooter
          showGridlines
          editMode="cell"
          @cell-edit-complete="onCellEditComplete"
        >
          <template #columns>
            <Column
              field="pr_no"
              header="No Pembelian"
              style="min-width: 12rem; background-color: rgb(248, 249, 250)"
            />
            <Column
              field="item_sku"
              header="SKU"
              class="bg-gray"
              style="min-width: 8rem; background-color: rgb(248, 249, 250)"
            />
            <Column
              field="item_barcode_1"
              header="Barcode"
              class="bg-gray"
              style="min-width: 8rem; background-color: rgb(248, 249, 250)"
            />
            <Column
              field="item_name"
              header="Deskripsi"
              class="bg-gray"
              style="min-width: 12rem; background-color: rgb(248, 249, 250)"
            />

            <Column
              field="unit_b"
              header="Satuan"
              class="bg-gray"
              style="min-width: 6rem; background-color: rgb(248, 249, 250)"
            >
              <template #body="slotProps">
                {{ slotProps.data.unit_b }}.{{ slotProps.data.unit_s }}
              </template>
            </Column>
            <Column
              field="ubox"
              header="ISI"
              class="bg-gray"
              style="min-width: 3rem; justify-content: flex-end"
            />
            <Column
              field="qty_b"
              header="qty (b)"
              style="min-width: 4rem; justify-content: flex-end"
            >
              <template #editor="{ data, field }">
                <InputText
                  :model-value="data[field]"
                  class="w-full text-right"
                  autofocus
                  @focus="$event.target.select()"
                  @update:model-value="data[field] = $event"
                  @keydown.enter.prevent="handleEnter(data, field, $event)"
                />
              </template>
            </Column>
            <Column
              field="qty_s"
              header="qty (s)"
              style="min-width: 4rem; justify-content: flex-end"
            >
              <template #editor="{ data, field }">
                <InputText
                  :model-value="data[field]"
                  class="w-full text-right"
                  autofocus
                  @focus="$event.target.select()"
                  @update:model-value="data[field] = $event"
                  @keydown.enter.prevent="handleEnter(data, field, $event)"
                />
              </template>
            </Column>
            <Column
              field="qty"
              header="QTY"
              class="bg-gray"
              style="
                min-width: 5rem;
                max-width: 6rem;
                background-color: rgb(248, 249, 250);
                justify-content: flex-end;
              "
            >
            </Column>

            <Column
              field="cost"
              header="Harga"
              style="min-width: 10rem; justify-content: flex-end"
            >
              <template #body="slotProps">
                <span style="text-align: right">
                  {{ formatCurrency(slotProps.data.cost, 2, 2) }}
                </span>
              </template>

              <template #editor="{ data, field }">
                <div class="p-inputgroup flex-1 w-full">
                  <span class="p-inputgroup-addon">Rp</span>

                  <InputText
                    :model-value="data[field]"
                    class="w-full text-right"
                    autofocus
                    @focus="$event.target.select()"
                    @update:model-value="data[field] = $event"
                    @keydown.enter.prevent="handleEnter(data, field, $event)"
                  />
                </div>
              </template>
            </Column>

            <Column
              field="cost_s"
              header="Harga (Net)"
              style="min-width: 10rem; justify-content: flex-end"
            >
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.cost_s, 2, 2 || 0) }}
              </template>
            </Column>

            <Column
              field="cost_per"
              header="PER"
              style="min-width: 4rem; justify-content: flex-start"
            >
            </Column>

            <Column
              field="disc_reg"
              header="DISC.REG"
              style="min-width: 10rem; justify-content: flex-end"
            >
              <template #body="slotProps">
                {{
                  slotProps.data.disc_reg > 100
                    ? formatCurrency(slotProps.data.disc_reg, 0, 0)
                    : `${formatPercentage(slotProps.data.disc_reg || 0, 0, 0)}%`
                }}
              </template>
              <template #editor="{ data, field }">
                <div class="w-full">
                  <div class="p-inputgroup w-full">
                    <span v-if="data[field] > 100" class="p-inputgroup-addon">
                      Rp
                    </span>

                    <InputNumber
                      v-model="data[field]"
                      locale="id-ID"
                      class="w-full"
                      input-class="w-full text-right"
                      :min="0"
                      :minFractionDigits="0"
                      :maxFractionDigits="0"
                      autofocus
                      @focus="$event.target.select()"
                    />

                    <span v-if="data[field] <= 100" class="p-inputgroup-addon">
                      %
                    </span>
                  </div>
                </div>
              </template>
            </Column>
            <Column
              field="disc_ext"
              header="DISC.EXT"
              style="min-width: 10rem; justify-content: flex-end"
            >
              <template #body="slotProps">
                {{
                  slotProps.data.disc_ext > 100
                    ? formatCurrency(slotProps.data.disc_ext || 0, 0, 0)
                    : `${formatPercentage(slotProps.data.disc_ext || 0, 0, 0)}%`
                }}
              </template>
              <template #editor="{ data, field }">
                <div class="w-full">
                  <div class="p-inputgroup w-full">
                    <span v-if="data[field] > 100" class="p-inputgroup-addon">
                      Rp
                    </span>

                    <InputNumber
                      v-model="data[field]"
                      locale="id-ID"
                      class="w-full"
                      input-class="w-full text-right"
                      :min="0"
                      :minFractionDigits="0"
                      :maxFractionDigits="0"
                      autofocus
                      @focus="$event.target.select()"
                    />

                    <span v-if="data[field] <= 100" class="p-inputgroup-addon">
                      %
                    </span>
                  </div>
                </div>
              </template>
            </Column>

            <Column
              field="tax"
              header="PPN"
              style="min-width: 3rem; justify-content: flex-end"
            >
              <template #body="slotProps">
                <span style="text-align: right">
                  {{ formatPercentage(slotProps.data.tax) }}%
                </span>
              </template>
            </Column>

            <!-- <Column
              field="bruto"
              header="Jumlah"
              class="bg-gray"
              style="
                min-width: 8rem;
                justify-content: flex-end;
                background-color: rgb(248, 249, 250);
              "
            >
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.bruto, 2, 2) }}
              </template>
            </Column> -->

            <Column
              field="dpp"
              header="Jumlah (Net)"
              style="
                min-width: 12rem;
                max-width: 12rem;
                background-color: #f8f9fa;
                justify-content: flex-end;
              "
            >
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.dpp, 2, 2 || 0) }}
              </template>
            </Column>

            <Column style="flex-grow: 1; justify-content: flex-end">
              <template #body="{ data }">
                <Button
                  type="button"
                  icon="pi pi-pencil"
                  class="
                    p-button-outlined p-button-secondary p-button-text
                    mr-2
                  "
                  :disabled="
                    old_status_value === 'printed' ||
                    old_status_value === 'posted'
                  "
                  @click="onEditData(data)"
                />
                <Button
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-outlined p-button-danger p-button-text"
                  :disabled="
                    old_status_value === 'printed' ||
                    old_status_value === 'posted'
                  "
                  @click="onConfirmDeletion(data)"
                />
              </template>
            </Column>
          </template>
          <template #footer>
            <table class="flex justify-content-end text-grey-200">
              <tr>
                <td width="100%">
                  <table class="justify-content-end text-700">
                    <tr>
                      <td>SUB TOTAL</td>
                      <td style="width: 150px" class="text-right">
                        {{ formatCurrency(totalPO.bruto, 2, 2 || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td>DISC REGULER</td>
                      <td class="text-right">
                        {{ formatCurrency(totalPO.disc_reg, 2, 2 || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td>DISC EXTRA</td>
                      <td class="text-right">
                        {{ formatCurrency(totalPO.disc_ext, 2, 2 || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td>PPN</td>
                      <td class="text-right">
                        {{ formatCurrency(totalPO.ppn, 0, 0 || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td>GRAND TOTAL</td>
                      <td class="text-right">
                        {{ formatCurrency(totalPO.total, 2, 2 || 0) }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </template>
        </fx-table>
      </div>
    </div>
    <!-- </form> -->
    <Dialog
      :header="'Tambah Item Penerimaan'"
      v-model:visible="dialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '95vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-purchase-order-receive
        :purchaseOrder="list_purchase_order"
        :excludeList="list_produk"
        :editMode="editMode"
        @save="onSaveData"
        @close="dialog = false"
      />
    </Dialog>
    <Dialog
      header="Edit Item Penerimaan"
      v-model:visible="dialogItem"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-purchase-order
        :item="formDetail"
        :loading="isLoadingSave"
        :list-satuan="list_satuan_unit"
        :editMode="editMode"
        :isDppMinus="isDppMinus"
        :isHideCheckBox="true"
        onMenu="receive"
        @save="onSaveDataItem"
        @close="dialogItem = false"
      />
    </Dialog>
    <Dialog
      header="Perubahan Supplier"
      v-model:visible="dialogSupplier"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :closable="false"
    >
      <div class="confirmation-content">
        <span>Item yang sudah diinput berbeda supplier, Ulangi Input ?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text p-button-secondary"
          @click="onNoSupplier(this.old_supplier_id)"
        />
        <Button label="Yes" @click="onYesSupplier" />
      </template>
    </Dialog>
    <Dialog
      header="Hapus Penerimaan"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Item Penerimaan <strong>{{ formDetail.item_name }}</strong> akan
          dihapus. Proses ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteItemPurchaseOrder"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import FxTable from '@/components/FxTable'
import Hotkey from '@/components/Hotkey'
import FormPurchaseOrder from '@/components/pembelian/FormPurchaseOrder'
import FormPurchaseOrderReceive from '@/components/pembelian/FormPurchaseOrderReceive'
import { focusNext, handleKeydown } from '@/helpers'
import errorHandler from '@/helpers/error-handler'
import { formatCurrency, formatPercentage } from '@/helpers/index'
import ItemService from '@/services/ItemService'
import PurchaseOrderService from '@/services/PurchaseOrderService'
import PurchaseReceiveService from '@/services/PurchaseReceiveService'
import SatuanService from '@/services/SatuanService'
import SettingService from '@/services/SettingService'
import SupplierService from '@/services/SupplierService'
import TermService from '@/services/TermService'
import useVuelidate from '@vuelidate/core'
import { helpers, maxLength, required } from '@vuelidate/validators'
import dayjs from 'dayjs'
import { FilterMatchMode } from 'primevue/api'
// import Badge from 'primevue/badge'
export default {
  setup: () => ({ v$: useVuelidate() }),
  name: 'PurchaseReceive',
  components: {
    FormPurchaseOrder,
    FormPurchaseOrderReceive,
    FxTable,
    Hotkey,
    // Badge,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
      submitted: false,
      settingService: null,
      itemService: null,
      satuanService: null,
      termService: null,
      supplierService: null,
      purchaseOrderService: null,
      purchaseReceiveService: null,
      dialog: false,
      dialogItem: false,
      dialogHapus: false,
      dialogSupplier: false,
      isLoading: false,
      isLoadingItem: false,
      isLoadingSave: false,
      isSetting: false,
      isDppMinus: false,
      editMode: false,
      old_status_value: 'draft',
      old_supplier_id: 0,
      supplierFilterValue: '',
      tax: 0,
      disc_reg: null,
      items: [],
      list_supplier: [],
      list_term: [],
      list_satuan: [],
      list_satuan_unit: [],
      list_global_setting: [],
      list_purchase_order: [],
      list_details_purchase: [],
      form: {
        rcv_no: '',
        sj_no: '',
        rcv_at: new Date(),
        sj_at: null,
        supp_id: '',
        // whouse: 0,
        status: 'draft',
        details: [],
      },
      formDetail: {},
      itemdetail: {
        qty_b: 0,
        qty_s: 0,
      },
      lastQtyInputRef: 'qty_b',
      list_items: [],
      filteredItems: [],
      selectedItem: null,
      isCheck: false,
      listDeleted: [],
      PurchaseOrder: [],
      containModesOption: [
        { label: 'Contains', value: FilterMatchMode.CONTAINS },
      ],
      equalModesOption: [{ label: 'Equals', value: FilterMatchMode.EQUALS }],
    }
  },
  computed: {
    roles() {
      const user = JSON.parse(localStorage.getItem('user'))
      const roles = user.roles

      if (roles && roles.length > 0) {
        return roles.map((item) => item.name)
      }
      return []
    },

    list_status() {
      const list = [
        { value: 'draft', label: 'Draft', level: 0 },
        { value: 'printed', label: 'Printed', level: 0 },
        { value: 'posted', label: 'Posted', level: 1 },
      ]
      let old_status_level = 0
      if (this.old_status_value) {
        const status = list.find((e) => e.value === this.old_status_value)
        if (status) old_status_level = status.level
      }
      return list.map((status) => ({
        ...status,
        disabled: status.disabled
          ? status.disabled
          : old_status_level > status.level,
      }))
    },
    list_produk() {
      return this.form.details.map((x) => `${x.pr_id}${x.prd_id}`)
    },
    totalPO() {
      // Calculate purchase.disc_reg
      let discRegTotal = this.form.details.reduce((total, detail) => {
        total += detail.disc_regv
        return total
      }, 0)

      let discExtTotal = this.form.details.reduce((total, detail) => {
        total += detail.disc_extv
        return total
      }, 0)

      // jumlah bruto
      let bruto = this.form.details.reduce((total, detail) => {
        total += detail.bruto
        return total
      }, 0)

      let dpp = bruto - discRegTotal - discExtTotal

      let total_ppn = this.form.details.reduce((total, detail) => {
        total += detail.dpp * (detail.tax / 100)
        return total
      }, 0)

      total_ppn = Math.floor(total_ppn)

      const total = {
        bruto: bruto,
        dpp: dpp,
        disc_reg: discRegTotal,
        disc_ext: discExtTotal,
        ppn: total_ppn,
        total: dpp + total_ppn,
      }
      return total
    },
    listItems() {
      return this.list_items.map((item) => ({
        ...item,
        label: `${item.item_barcode_1} - ${item.item_name}`,
      }))
    },
  },
  watch: {
    'form.supp_id'(value) {
      if (this.form.details.length > 0) {
        this.purchaseOrderService
          .getById(`${this.form.details[0].pr_id}`)
          .then((res) => {
            if (res.data.data.supp_id !== value) {
              this.dialogSupplier = true
              this.old_supplier_id = res.data.data.supp_id
            }
            this.purchaseOrderService
              .getItemPO(
                `?status=done&supp_id=${res.data.data.supp_id}&receive=0`
              )
              .then((res) => {
                if (!res.data.data || res.data.data.length === 0) {
                  this.$toast.add({
                    severity: 'warn',
                    summary: 'Penerimaan',
                    detail: `Penerimaan untuk pelanggan ${res.data.data.supplier.name} tidak ditemukan!`,
                    life: 3000,
                  })
                  this.isLoadingItem = false
                } else {
                  this.list_purchase_order = res.data.data
                  this.isLoadingItem = false
                }
              })
              .catch(() => {
                this.isLoadingItem = false
              })
          })
          .catch((err) => {
            errorHandler(err, 'Data Supplier', this)
          })
      }
    },
  },
  created() {
    this.purchaseOrderService = new PurchaseOrderService()
    this.purchaseReceiveService = new PurchaseReceiveService()
    this.termService = new TermService()
    this.supplierService = new SupplierService()
    this.satuanService = new SatuanService()
    this.itemService = new ItemService()
    this.settingService = new SettingService()
  },
  async mounted() {
    if (this.id > 0) {
      this.isSetting = true
      this.loadData()
      this.isSetting = false
    }

    this.settingService
      .get()
      .then((res) => {
        this.list_global_setting = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Setting', this)
      })
      .finally(() => (this.isLoading = false))

    this.supplierService
      .getActive()
      .then((res) => {
        this.list_supplier = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Supplier', this)
      })
      .finally(() => (this.isLoading = false))

    this.termService
      .get()
      .then((res) => {
        this.list_term = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Termin', this)
      })

    this.satuanService
      .get()
      .then((res) => {
        this.list_satuan = res.data.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Satuan', this)
      })
  },
  methods: {
    handleItemSelect(event) {
      this.selectItem(event)
      this.focusNext('qty_b')
    },
    selectAllText(event) {
      if (event) {
        this.$refs[event].$el.querySelector('input').select()
      }
    },
    selectSupplier() {
      this.list_purchase_order = []
      this.list_items = []

      this.itemdetail = {
        pr_id: null,
        qty_b: 0,
        qty_s: 0,
      }

      this.selectedItem = null
    },
    onSupplierFilter(event) {
      this.supplierFilterValue = event.value
    },
    async onSupplierSelected() {
      if (!this.form.supp_id) return

      this.isLoadingItem = true

      try {
        const res = await this.purchaseOrderService.getItemPO(
          `?status=done&supp_id=${this.form.supp_id}&receive=0`
        )

        if (!res.data.data || res.data.data.length === 0) {
          const supplier = this.list_supplier.find(
            (s) => s.id === this.form.supp_id
          )

          const supplierName = supplier ? supplier.name : '(Tidak diketahui)'

          this.$toast.add({
            severity: 'warn',
            summary: 'Penerimaan',
            detail: `PO untuk supplier "${supplierName}" tidak ditemukan!`,
            life: 3000,
          })

          this.list_purchase_order = []

          await this.$nextTick()

          setTimeout(() => {
            const dropdown = this.$refs.supp_id
            if (!dropdown) return
            // focus
            dropdown.focus?.()
            // buka overlay
            dropdown.show?.()
            // restore keyword filter
            if (dropdown.filterInput) {
              dropdown.filterInput.value = this.supplierFilterValue
              dropdown.onFilterInput({
                target: dropdown.filterInput,
              })
              dropdown.filterInput.focus()
            }
          }, 150)
          return
        }

        this.list_purchase_order = res.data.data
        await this.$nextTick()
        setTimeout(() => {
          const dropdown = this.$refs.pr_id
          if (!dropdown) return
          dropdown.focus?.()
          dropdown.show?.()
        }, 150)
      } finally {
        this.isLoadingItem = false
      }
    },
    selectPo() {
      if (!this.form.supp_id) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Validasi',
          detail: 'Harap pilih supplier terlebih dahulu',
          life: 3000,
        })
        this.itemdetail = { pr_id: null, qty_b: 0, qty_s: 0 }
        return
      }

      this.list_items = []
      this.itemdetail = {
        pr_id: this.itemdetail.pr_id, // simpan id PO
        qty_b: 0,
        qty_s: 0,
      }
      this.selectedItem = null

      const po = this.list_purchase_order.find(
        (p) => p.id === this.itemdetail.pr_id
      )

      if (!po) return

      const existing = this.list_produk || []

      this.list_items = po.details
        .map((el) => {
          const key = `${String(po.id)}${String(el.id)}`
          return {
            ...el,
            pr_no: po.pr_no,
            pr_id: po.id,
            prd_id: el.id,
            key,
            qty_edit: el.qty_edit ?? 0,
          }
        })
        .filter((el) => !existing.includes(String(el.key)))
    },
    async onPoSelected() {
      if (!this.itemdetail.pr_id) return

      await this.$nextTick()

      setTimeout(() => {
        this.focusNext('item_id')
      }, 100)
    },
    searchItem(event) {
      const query = event.query?.toLowerCase() || ''

      this.purchaseReceiveService
        .getBy(`/check_item?pr_id=${this.itemdetail.pr_id}&item_id=${query}`)
        .then(() => {
          this.filteredItems = this.listItems.filter((item) => {
            return (
              (item.item_barcode_1 &&
                item.item_barcode_1.toLowerCase().includes(query)) ||
              (item.item_barcode_2 &&
                item.item_barcode_2.toLowerCase().includes(query)) ||
              (item.item_sku && item.item_sku.toLowerCase().includes(query)) ||
              (item.item_name && item.item_name.toLowerCase().includes(query))
            )
          })

          if (query && this.filteredItems.length === 0) {
            this.$toast.add({
              severity: 'warn',
              summary: 'Item tidak ada di PO',
              detail: `Barcode/Item "${event.query}" tidak ditemukan di PO`,
              life: 3000,
            })
            this.selectedItem = null
          }
        })
        .catch((err) => {
          let msg = err.response?.data?.message || ''
          if (
            msg.toLowerCase().includes('sql') ||
            msg.toLowerCase().includes('duplicate entry') ||
            msg.toLowerCase().includes('constraint') ||
            msg.toLowerCase().includes('violation') ||
            msg.toLowerCase().includes('syntax') ||
            msg.toLowerCase().includes('timeout') ||
            msg === ''
          ) {
            msg = `Barcode/Item "${event.query}" sudah ditambahkan di penerimaan lain`
          }

          this.$toast.add({
            severity: 'warn',
            summary: 'Item sudah diterima',
            detail: msg,
            life: 3000,
          })

          this.filteredItems = []
          this.selectedItem = null
        })

        .finally(() => {
          this.isLoadingItem = false
        })
    },

    selectItem(event) {
      if (!this.form.supp_id || !this.itemdetail.pr_id) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Validasi',
          detail: 'Harap pilih supplier dan PO terlebih dahulu',
          life: 3000,
        })
        this.selectedItem = null
        return
      }

      // reset qty sebelum assign
      this.itemdetail.qty_b = 0
      this.itemdetail.qty_s = 0

      const item = event.value
      this.itemdetail = {
        ...this.itemdetail,
        ...item,
        qty_b: 0,
        qty_s: 0,
        pr_id: this.itemdetail.pr_id,
        prd_id: item.id,
        max_qty_b: item.qty_b,
        max_qty_s: item.qty_s,
        max_qty_total: item.qty_b * item.ubox + item.qty_s,
      }
    },
    onCellEditComplete(event) {
      const { data, field, newValue } = event

      data[field] = newValue

      const totalDetail = this.totalDetail(data)

      if (!totalDetail) {
        return
      }

      Object.assign(data, totalDetail)

      if (data.cost <= 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Order Pembelian',
          detail: 'Harga harus lebih dari 0',
          life: 3000,
        })
      }
    },
    handleEnter(data, field, event) {
      const result = this.calculateExpression(data[field])

      if (result === null) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Kalkulator',
          detail: 'Ekspresi matematika tidak valid',
          life: 3000,
        })
        return
      }

      data[field] = result
      event.target.blur()
    },

    calculateExpression(value) {
      if (typeof value === 'number') {
        return value
      }

      const expression = String(value ?? '')
        .replace(/\s+/g, '')
        .replace(/,/g, '.')

      if (!expression) {
        return 0
      }

      if (!/^[\d.+\-*/()%]+$/.test(expression)) {
        return null
      }

      try {
        const result = Function(`"use strict"; return (${expression})`)()

        if (!Number.isFinite(result)) {
          return null
        }

        return result
      } catch {
        return null
      }
    },

    totalDetail(detail) {
      const cost = Number(detail.cost) || 0

      if (cost <= 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Min harga satuan harus lebih dari 0',
          life: 3000,
        })
        return
      }

      // ===== total qty =====
      const qty_b = Number(detail.qty_b) || 0
      const qty_s = Number(detail.qty_s) || 0
      const ubox = Number(detail.ubox) || 0

      const qty = qty_b * ubox + qty_s
      const maxQty = Number(detail.max_qty_total) || 0

      if (qty <= 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Qty harus lebih dari 0',
          life: 3000,
        })
        return
      }

      if (qty > maxQty) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: `Qty melebihi PO. Maksimal ${maxQty} pcs`,
          life: 3000,
        })
        return
      }

      // ===== harga satuan & bruto =====
      let cost_s = 0

      if (detail.cost_per === detail.unit_b) {
        if (ubox <= 0) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Penerimaan',
            detail: 'Konversi unit per box harus lebih dari 0',
            life: 3000,
          })
          return
        }

        cost_s = Number((cost / ubox).toFixed(2))
      } else {
        cost_s = Number(cost.toFixed(2))
      }

      const bruto = Number((cost_s * qty).toFixed(2))

      // ===== disc reg =====
      let disc_regv = 0
      const disc_reg = Number(detail.disc_reg) || 0

      if (disc_reg >= 1 && disc_reg <= 100) {
        disc_regv = Number((cost_s * (disc_reg / 100)).toFixed(2))
      } else if (disc_reg > 100) {
        disc_regv = Number(disc_reg.toFixed(2))
      }

      cost_s = Number((cost_s - disc_regv).toFixed(2))

      if (cost_s < 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Total diskon reguler tidak dapat melebihi harga satuan.',
          life: 3000,
        })
        return
      }

      disc_regv = Number((disc_regv * qty).toFixed(2))

      // ===== disc ext =====
      let disc_extv = 0
      const disc_ext = Number(detail.disc_ext) || 0

      if (disc_ext >= 1 && disc_ext <= 100) {
        disc_extv = Number((cost_s * (disc_ext / 100)).toFixed(2))
      } else if (disc_ext > 100) {
        disc_extv = Number(disc_ext.toFixed(2))
      }

      cost_s = Number((cost_s - disc_extv).toFixed(2))

      if (cost_s < 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Total diskon extra tidak dapat melebihi harga satuan.',
          life: 3000,
        })
        return
      }

      disc_extv = Number((disc_extv * qty).toFixed(2))

      // ===== dpp =====
      const dpp = Number((cost_s * qty).toFixed(2))

      // ===== harga jual baru =====
      const margin_pst = Number(detail.margin_pst) || 0
      const tax = Number(this.form.tax) || 0

      let price = 0

      if (margin_pst < 100) {
        price = cost_s / (1 - margin_pst / 100)

        const ppn = Math.floor(price * (tax / 100))
        price = Number((price + ppn).toFixed(2))
      } else {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Margin harus kurang dari 100%.',
          life: 3000,
        })
        return
      }

      // ===== margin perubahan harga =====
      let margin = 0
      const oldPrice = Number(detail.price) || 0

      if (oldPrice > 0) {
        margin = Number((((price - oldPrice) / oldPrice) * 100).toFixed(2))
      }

      // ===== mark =====
      let mark = 0

      if (price > oldPrice) mark = 1
      else if (price < oldPrice) mark = 2

      return {
        qty,
        bruto,
        dpp,
        total: dpp,
        price,
        margin,
        mark,
        disc_regv,
        disc_extv,
      }
    },
    changeDiscReg() {
      if (this.isSetting == false) {
        this.form.details.forEach((item) => {
          item.disc_reg = this.disc_reg
          const totalDetail = this.totalDetail(item)
          Object.assign(item, { ...item, ...totalDetail })
        })
      }
    },
    save(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }
      if (this.form.details.length < 1) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Setidaknya 1 item data',
          life: 3000,
        })
        return
      }

      const deleted = this.id ? { deleted: this.listDeleted } : {}

      const rcv_at = this.form.rcv_at
        ? { rcv_at: dayjs(this.form.rcv_at).format('YYYY-MM-DD') }
        : null

      const sj_at = this.form.sj_at
        ? { sj_at: dayjs(this.form.sj_at).format('YYYY-MM-DD') }
        : null

      const form = {
        ...rcv_at,
        // ...sj_at,
        sj_at: this.form.sj_at != null ? sj_at : null,
        sj_no: this.form.sj_no,
        rcv_no: this.form.rcv_no,
        supp_id: this.form.supp_id,
        // whouse: this.form.whouse,
        status: this.form.status,
        details: this.form.details.map((item) => {
          const id = item.id ? { id: item.id } : this.id ? { id: 0 } : {}
          return {
            ...id,
            prd_id: item.prd_id,
            qty_b: item.qty_b,
            qty_s: item.qty_s,
            cost: item.cost,
            disc_reg: item.disc_reg,
            disc_ext: item.disc_ext,
            tax: item.tax,
          }
        }),
        ...deleted,
      }

      if (!this.id) {
        this.isLoadingSave = true
        form.sj_at =
          this.form.sj_at != null
            ? dayjs(this.form.sj_at).format('YYYY-MM-DD')
            : null
        this.purchaseReceiveService
          .add(form)
          .then((res) => {
            if (res.data.status === 1) {
              this.$toast.add({
                severity: 'success',
                summary: 'Penerimaan',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })

              this.$router.push({ name: 'PurchaseReceive' })
            }
          })
          .catch((err) => {
            errorHandler(err, 'Penerimaan', this)
          })
          .finally(() => {
            this.deleted = []
            this.isLoadingSave = false
          })
      } else {
        this.isLoadingSave = true
        form.sj_at =
          this.form.sj_at != null
            ? dayjs(this.form.sj_at).format('YYYY-MM-DD')
            : null
        this.purchaseReceiveService
          .update(this.id, form)
          .then((res) => {
            if (res.data.status === 1) {
              this.loadData()
              this.$toast.add({
                severity: 'success',
                summary: 'Penerimaan',
                detail: 'Data berhasil diupdate.',
                life: 3000,
              })
              if (this.form.status === 'printed') {
                this.$router.push({ name: 'PurchaseReceive' })
              }
            }
          })
          .catch((err) => {
            errorHandler(err, 'Penerimaan', this)
          })
          .finally(() => {
            this.isLoadingSave = false
          })
      }
    },
    formatCurrency(val, minDigit = 2, maxdigit = 2) {
      return formatCurrency(val, minDigit, maxdigit)
    },
    formatPercentage(val, minDigit = 0, maxDigit = 0) {
      return formatPercentage(val, minDigit, maxDigit)
    },

    loadData() {
      this.isLoading = true
      this.purchaseReceiveService
        .getById(this.id)
        .then((res) => {
          this.form = res.data.data
          this.form.rcv_at = this.form.rcv_at ? new Date(this.form.rcv_at) : ''
          this.old_status_value = this.form.status
        })
        .catch((err) => {
          errorHandler(err, 'Data Penerimaan', this)
        })
        .finally(() => (this.isLoading = false))
    },

    onEditData(data) {
      this.editMode = true
      this.formDetail = Object.assign({}, data)
      this.purchaseOrderService
        .getById(this.formDetail.pr_id)
        .then((res) => {
          this.list_details_purchase = res.data.data.details

          const idx = this.list_details_purchase.findIndex(
            (item) => item.item_id === this.formDetail.item_id
          )
          if (idx !== -1) {
            const detailsPurchase = this.list_details_purchase[idx]
            this.list_satuan_unit = this.list_satuan.filter(
              (item) =>
                item.sat === 'PCS' ||
                item.sat === detailsPurchase.unit_b ||
                item.sat === detailsPurchase.unit_s ||
                item.sat === this.formDetail.unit_b ||
                item.sat === this.formDetail.unit_s
            )
          } else {
            this.list_satuan_unit = this.list_satuan
          }
          this.dialogItem = true
          this.isLoading = false
        })
        .catch((err) => {
          console.log('err', err)
          // this.isLoadingItem = false
        })
        .finally(() => (this.isLoading = false))
    },
    onAddData() {
      this.editMode = false

      if (!this.form.supp_id) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan',
          detail: 'Supplier harus diisi terlebih dahulu.',
          life: 3000,
        })
        return
      }

      const supplier = this.list_supplier.filter(
        (item) => item.id === this.form.supp_id
      )[0]
      this.isLoadingItem = true
      this.purchaseOrderService
        .getItemPO(`?status=done&supp_id=${this.form.supp_id}&receive=0`)
        .then((res) => {
          if (!res.data.data || res.data.data.length === 0) {
            this.$toast.add({
              severity: 'warn',
              summary: 'Penerimaan',
              detail: `Penerimaan untuk pelanggan ${supplier.name} tidak ditemukan!`,
              life: 3000,
            })
            this.isLoadingItem = false
          } else {
            this.list_purchase_order = res.data.data
            this.dialog = true
            this.isLoadingItem = false
          }
        })
        .catch(() => {
          this.isLoadingItem = false
        })
    },
    async onSaveReceiveItem() {
      if (
        !this.form.supp_id ||
        !this.itemdetail.pr_id ||
        !this.itemdetail.prd_id
      ) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Validasi',
          detail: 'Supplier, PO, dan Item harus dipilih',
          life: 3000,
        })
        return
      }

      if (
        (this.itemdetail.qty_b || 0) <= 0 &&
        (this.itemdetail.qty_s || 0) <= 0
      ) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Validasi',
          detail: 'Qty harus diisi lebih dari 0',
          life: 3000,
        })
        return
      }

      const detailItem = { ...this.itemdetail }

      // ===== hitung qty input (dalam pcs) =====
      const inputQty =
        (detailItem.qty_b || 0) * detailItem.ubox + (detailItem.qty_s || 0)

      // ===== hitung max qty dari PO (dalam pcs) =====
      const maxQty =
        (detailItem.max_qty_b || 0) * detailItem.ubox +
        (detailItem.max_qty_s || 0)

      // ===== ambil existing item (jika sudah pernah ditambahkan) =====
      const key = `${detailItem.pr_id}-${detailItem.prd_id}`

      const existingItem = this.form.details.find(
        (item) => `${item.pr_id}-${item.prd_id}` === key
      )

      const existingQty = existingItem
        ? (existingItem.qty_b || 0) * existingItem.ubox +
          (existingItem.qty_s || 0)
        : 0

      // ===== validasi over qty =====
      if (inputQty + existingQty > maxQty) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Validasi',
          detail: `Total qty melebihi PO. Maksimal ${maxQty} pcs`,
          life: 3000,
        })
        this.focusNext(this.lastQtyInputRef)
        return
      }

      // ===== hitung total (harga, dll) =====
      const totalDetail = await this.totalDetail(detailItem)

      const idx = this.form.details.findIndex(
        (item) => `${item.pr_id}-${item.prd_id}` === key
      )

      if (idx !== -1) {
        // ✅ akumulasi qty, bukan overwrite
        this.form.details[idx].qty_b += detailItem.qty_b || 0
        this.form.details[idx].qty_s += detailItem.qty_s || 0

        // update field lain
        Object.assign(this.form.details[idx], {
          ...totalDetail,
          id: this.form.details[idx].id || 0,
        })
      } else {
        this.form.details.push({
          ...detailItem,
          ...totalDetail,
          id: 0,
        })
      }

      // ===== reset input =====
      this.itemdetail = {
        pr_id: this.itemdetail.pr_id,
        qty_b: 0,
        qty_s: 0,
      }

      this.selectedItem = null
      this.selectPo()
      await this.$nextTick()
      await this.$nextTick()

      setTimeout(() => {
        focusNext(this, 'item_id')
      }, 100)
    },
    async onSaveData(data) {
      data.map(async (detailItem) => {
        const idx = this.form.details.findIndex(
          (item) =>
            item.pr_id === detailItem.pr_id && item.prd_id === detailItem.prd_id
        )
        const totalDetail = await this.totalDetail(detailItem)
        if (idx === -1) {
          delete detailItem.id

          this.form.details.push({ ...detailItem, ...totalDetail })
          this.$toast.add({
            severity: 'success',
            summary: 'Penerimaan',
            detail: 'Data Item berhasil ditambahkan.',
            life: 3000,
          })
          this.dialog = false
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Penerimaan',
            detail: `Item ${detailItem.no_po} sudah ada`,
            life: 3000,
          })
        }
      })
    },
    async onSaveDataItem(data) {
      const detailItem = Object.assign({}, data)

      // ===== Validasi awal =====
      if (
        !this.form.supp_id ||
        !detailItem.pr_id ||
        !detailItem.prd_id ||
        ((detailItem.qty_b || 0) <= 0 && (detailItem.qty_s || 0) <= 0)
      ) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan Barang',
          detail: 'Harap isi data detail item dengan benar',
          life: 3000,
        })
        this.isFormSuccess = false
        return
      }

      // ===== Hitung qty input (pcs) =====
      const inputQty =
        (detailItem.qty_b || 0) * detailItem.ubox + (detailItem.qty_s || 0)

      // ===== Tentukan max qty dari PO =====
      const maxQty =
        detailItem.id > 0
          ? (detailItem.po_qty_b || 0) * detailItem.ubox +
            (detailItem.po_qty_s || 0)
          : (detailItem.max_qty_b || 0) * detailItem.ubox +
            (detailItem.max_qty_s || 0)

      // ===== Key item =====
      const key = `${detailItem.pr_id}-${detailItem.prd_id}`

      // ===== Ambil semua item dengan key sama =====
      const sameItems = this.form.details.filter(
        (item) => `${item.pr_id}-${item.prd_id}` === key
      )

      // ===== Hitung total existing =====
      let totalExistingQty = sameItems.reduce((sum, item) => {
        return sum + (item.qty_b || 0) * item.ubox + (item.qty_s || 0)
      }, 0)

      // ===== Jika edit → kurangi qty lama item ini =====
      if (this.editMode) {
        const oldItem = sameItems.find((item) => item.id === detailItem.id)

        if (oldItem) {
          const oldQty =
            (oldItem.qty_b || 0) * oldItem.ubox + (oldItem.qty_s || 0)

          totalExistingQty -= oldQty
        }
      }

      // ===== Validasi over qty =====
      if (inputQty + totalExistingQty > maxQty) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Penerimaan Barang',
          detail: `Total qty melebihi PO. Maksimal ${maxQty} pcs`,
          life: 3000,
        })
        this.isFormSuccess = false
        return
      }

      // ===== Hitung total harga =====
      const totalDetail = await this.totalDetail(detailItem)
      if (!totalDetail) {
        this.isFormSuccess = false
        return
      }

      const idx = this.form.details.findIndex(
        (item) => `${item.pr_id}-${item.prd_id}` === key
      )

      if (this.editMode) {
        // ===== EDIT MODE =====
        if (idx !== -1) {
          Object.assign(this.form.details[idx], {
            ...detailItem,
            ...totalDetail,
          })

          this.$toast.add({
            severity: 'success',
            summary: 'Penerimaan Barang',
            detail: 'Item berhasil diperbarui.',
            life: 2000,
          })
        }

        this.dialogItem = false
        this.isFormSuccess = true
        this.editMode = false
      } else {
        // ===== ADD MODE =====
        if (idx === -1) {
          this.form.details.push({
            ...detailItem,
            ...totalDetail,
            id: 0,
          })

          this.$toast.add({
            severity: 'success',
            summary: 'Penerimaan Barang',
            detail: 'Item berhasil ditambahkan.',
            life: 2000,
          })

          this.isFormSuccess = true
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Penerimaan Barang',
            detail: 'Item sudah ada di daftar.',
            life: 3000,
          })
          this.isFormSuccess = false
        }
      }
    },

    onConfirmDeletion(data) {
      this.formDetail = data
      this.dialogHapus = true
    },
    onDeleteItemPurchaseOrder() {
      const index = this.form.details.findIndex(
        (el) => el.item_id === this.formDetail.item_id
      )
      if (index !== -1) {
        if (this.id && this.form.details[index].id) {
          this.listDeleted.push(this.form.details[index].id)
        }
        this.form.details.splice(index, 1)
        this.$toast.add({
          severity: 'success',
          summary: 'Data Item Penerimaan',
          detail: 'Data berhasil dihapus.',
          life: 3000,
        })
        this.selectPo()
      }
      this.dialogHapus = false
    },
    onYesSupplier() {
      this.form.details = []
      this.itemdetail = {}
      this.dialogSupplier = false
      this.selectSupplier()
    },
    onNoSupplier(value) {
      this.$refs.supp_id.filterValue = ''
      this.form.supp_id = value
      this.dialogSupplier = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.onAddData()
      }
    },
    handleKeydown(event, nextRef, prevRef = null) {
      handleKeydown(this, event, nextRef, prevRef)
    },
    focusNext(refName) {
      focusNext(this, refName)
    },
  },
  validations() {
    return {
      form: {
        supp_id: {
          required: helpers.withMessage('Supplier harus diisi.', required),
        },
      },
      itemdetail: {
        qty_b: {
          required: helpers.withMessage('QTY(B) harus diisi.', required),
          maxLength: helpers.withMessage(
            'Nilai digit qty_b tidak boleh lebih dari 6 digit',
            maxLength(6)
          ),
        },
        qty_s: {
          required: helpers.withMessage('QTY(S) harus diisi.', required),
          maxLength: helpers.withMessage(
            'Nilai digit qty_s tidak boleh lebih dari 6 digit',
            maxLength(6)
          ),
        },
      },
    }
  },
}
</script>

<style scoped>
.p-datatable .p-cell-editing {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  overflow: visible !important;
}

.p-datatable .p-cell-editor {
  width: 100%;
}

.p-datatable .p-inputgroup {
  width: 100%;
}

.p-datatable .p-inputnumber {
  width: 100%;
}

.p-datatable td {
  overflow: visible !important;
}
</style>
